import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Data, NavigationEnd, Route, Router, ROUTES, Routes } from '@angular/router';
import { BehaviorSubject, filter } from 'rxjs';

import { Breadcrumb } from '../models/breadcrumb.model';

@Injectable({
    providedIn: 'root'
})
export class BreadcrumbService {

    private readonly router = inject(Router);

    private readonly _breadcrumbs$ = new BehaviorSubject<Breadcrumb[]>([]);

    readonly breadcrumbs$ = this._breadcrumbs$.asObservable();

    routes!: Routes;

    constructor() {

        let routes = inject(ROUTES);

        this.routes = routes && routes[0];

        this.router.events.pipe(
            filter((event) => event instanceof NavigationEnd)
        ).subscribe(event => {
            const root = this.router.routerState.snapshot.root;
            const breadcrumbs: Breadcrumb[] = [];

            const homeRoute = this.routes?.find(r => r.path == '');
            if (root.url.length || root.children.some(c => c.url.length)) {
                breadcrumbs.push({
                    label: '',
                    html: '',
                    url: '',
                    enabled: true,
                    ...this.getData(homeRoute?.data)
                })
            }
            this.addBreadcrumb(root, [], breadcrumbs);

            this._breadcrumbs$.next(breadcrumbs);
        });


    }

    private addBreadcrumb(route: ActivatedRouteSnapshot | null, parentUrl: string[], breadcrumbs: Breadcrumb[]) {
        if (route) {
            const routeUrl = parentUrl.concat(route.url.map(url => url.path));

            if (route.data['breadcrumb']) {
                const routeUrlString = '/' + routeUrl.join('/')
                if (!breadcrumbs.some(bc => bc.url.toLowerCase() == routeUrlString.toLowerCase())) {
                    const data = this.getData(route.data);
                    const breadcrumb: Breadcrumb = {
                        label: '',
                        html: '',
                        url: routeUrlString,
                        ...data,
                        enabled: data.enabled == true && !this.router.isActive(routeUrlString, { paths: 'exact', fragment: 'ignored', matrixParams: 'ignored', queryParams: 'ignored' }),
                    };
                    breadcrumbs.push(breadcrumb);
                }
            }

            this.addBreadcrumb(route.firstChild, routeUrl, breadcrumbs);
        }
    }

    private getData(data?: Data): Partial<Breadcrumb> {
        let breadcrumb = data && data['breadcrumb'];
        const bc = typeof breadcrumb === 'function' ? breadcrumb(data) : breadcrumb;
        return { enabled: true, ...bc };
    }

}
